import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Spin } from 'antd';
import useHouseCameras from '../../../queries/useHouseCameras';
import useIntersectionObserver from '../../../../../hooks/useIntersectionObserver';
import Camera from '../Camera/Camera';
import styles from './CamerasCell.module.scss';

const CamerasCell = ({ houseId, address }) => {
  const containerRef = useRef();

  const [queryEnabled, setQueryEnabled] = useState(false);
  const [uniqueCameras, setUniqueCameras] = useState([]);

  const handleIntersect = useCallback(
    ([{ isIntersecting }], observerElement) => {
      if (isIntersecting) {
        setQueryEnabled(true);

        observerElement.unobserve(containerRef.current);
      }
    },
    []
  );

  useIntersectionObserver({
    target: containerRef,
    onIntersect: handleIntersect,
    threshold: 0.2,
  });

  const { data: cameras, isFetching: isCamerasFetching } = useHouseCameras(
    { houseId, address },
    {
      enabled: Boolean(houseId && address) && queryEnabled,
      staleTime: Infinity,
    }
  );

  useEffect(() => {
    let newCameras = [];

    if (Boolean(cameras?.length)) {
      const result = cameras.reduce((acc, camera) => {
        const item = acc.get(camera.id);

        if (!item) {
          acc.set(camera.id, camera);
        }

        return acc;
      }, new Map());

      newCameras = Array.from(result.values());
    }

    setUniqueCameras(newCameras);
  }, [cameras]);

  return (
    <Spin spinning={isCamerasFetching}>
      <div ref={containerRef} className={styles.root}>
        {Boolean(uniqueCameras.length) &&
          uniqueCameras
            .slice(0, 7)
            .map((camera) => <Camera key={camera.id} data={camera} />)}
      </div>
    </Spin>
  );
};

export default CamerasCell;
